<app-carousel-people [slides]="slides"></app-carousel-people>